export enum OperatingModesForE3 {
  constantMode = 0,
  timeSchedule = 1,
  timeScheduleWithInternalSensor = 2,
  sensorBasedAutomaticMode = 3,
  constantModeWithInternalSensor = 4,
}
export enum OperatingModesForLegacy {
  standby = 0,
  normal = 1,
  timeSchedule = 2,
}
export enum ProgramsInLegendForE3 {
  level1 = 0,
  level2 = 1,
  level3 = 2,
}
export enum ProgramsInLegendForLegacy {
  level1 = 0,
  level2 = 1,
  level3 = 2,
  level4 = 3,
}
export enum ProgramSelectDropdownForLegacy {
  level2 = 0,
  level3 = 1,
  level4 = 2,
}
export enum ProgramSelectDropdownForE3 {
  level2 = 0,
  level3 = 1,
}
export enum ProgramsInDropdownForE3 {
  level1 = 0,
  level2 = 1,
  level3 = 2,
  level4 = 3,
}
export enum BypassModes {
  off = 0,
  automaticSmoothRegulation = 1,
  smoothDynamicRegulation = 2,
}
export enum QuickSelectionsModes {
  silentVentilation = 'silent',
  intensive = 'intensive',
  temporaryShutdown = 'temporaryShutdown',
}
export enum QuickSelectionsDropdowns {
  hours = 0,
  minutes = 1,
}
export enum DiagnosticInformation {
  heatExchangerFrostDamagePreventionStatus = 0,
  filterStatus = 1,
  filterOperatingHours = 2,
  filterRemainingLifetime = 3,
  filterLifetimeOverdue = 4,
  lastServiceDate = 5,
  nextServiceDate = 6,
  lastFilterChange = 7,
  nextFilterChange = 8,
}
export enum ValueFromTimeDropdown {
  hour0 = 0,
  minute1 = 1,
  hour1 = 1,
}
export enum DaysFromEditMultipleDaysModal {
  monday = 0,
  tuesday = 1,
  wednesday = 2,
  thursday = 3,
  friday = 4,
  saturday = 5,
  sunday = 6,
}
export enum StartAndEndTimeForProgram {
  time_00_00 = 0,
  time_00_10 = 1,
  time_00_20 = 2,
  time_00_30 = 3,
  time_05_00 = 29,
  time_05_10 = 30,
}

export const ventilationOperatingModes = {
  E_3: ['permanent', 'ventilation', 'sensorOverride', 'sensorDriven'],
  KEYS: {
    CONSTANT_MODE: 'permanent',
    SENSOR_DRIVEN: 'sensorDriven',
    SENSOR_OVERRIDE: 'sensorOverride',
    STANDARD: 'standard',
    STANDBY: 'standby',
    TIME_SCHEDULE: 'ventilation',
  },
  LEGACY: ['standby', 'standard', 'ventilation'],
};

export const ventilationOperatingPrograms = {
  E3_SCHEDULE: ['levelOne', 'levelTwo', 'levelThree'],
  KEYS: {
    LEVEL_1: 'levelOne',
    LEVEL_2: 'levelTwo',
    LEVEL_3: 'levelThree',
    LEVEL_4: 'levelFour',
    STANDBY: 'standby',
  },
  LEGACY_SCHEDULE: ['levelOne', 'levelTwo', 'levelThree', 'levelFour'],
};

export enum VentilationBypassModes {
  Off = 'off',
  AutomaticSmoothRegulation = 'automaticSmoothRegulation',
  SmoothDynamicRegulation = 'automaticDynamicRegulation',
}

export enum VentilationBypassStates {
  Off = 'off',
  Inactive = 'Inactive',
  Active = 'Active',
}
